<template>
  <div class="app-container">
    <table>
      <tr>
        <th>Curso</th>
        <td>{{ timetable.course_name }}</td>
      </tr>
      <tr>
        <th>Fecha de Ini. - Fin</th>
        <td>{{ timetable.date_start }} - {{ timetable.date_finish }}</td>
      </tr>
      <tr>
        <th>Profesor</th>
        <td>{{ timetable.user_name }}</td>
      </tr>
      <tr>
        <th>Día de la semana</th>
        <td>
          <span v-html="getWeekDay(date)"></span>
        </td>
      </tr>
      <tr>
        <th>Horario</th>
        <td>{{ timetable.start }} - {{ timetable.finish }}</td>
      </tr>
      <tr>
        <th>Nº Alumnos/Total</th>
        <td>{{ timetable.num_students }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
  export default {
    props: ['timetable_id', 'date'],
    data() {
      return {
        timetable: {},
      };
    },
    created() {
      this.getTimetable();
    },
    methods: {
      getTimetable() {
        axios.get(`/timetables-json/${this.timetable_id}`)
        .then(res => {
          this.timetable = res.data.data;
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      getFormatedDate(date) {
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();

        if (day < 10) {
          day = '0' + day;
        }
        if (month < 10) {
          month = '0' + month;
        }

        return day + '/' + month + '/' + year;
      },
      getWeekDay(date) {
        var weekday = new Array(7);
        weekday[0] = `<span class=\"label label-fill label-info\">Domingo ${this.getFormatedDate(date)}</span>`;
        weekday[1] = `<span class=\"label label-fill label-info\">Lunes ${this.getFormatedDate(date)}</span>`;
        weekday[2] = `<span class=\"label label-fill label-info\">Martes ${this.getFormatedDate(date)}</span>`;
        weekday[3] = `<span class=\"label label-fill label-info\">Miércoles ${this.getFormatedDate(date)}</span>`;
        weekday[4] = `<span class=\"label label-fill label-info\">Jueves ${this.getFormatedDate(date)}</span>`;
        weekday[5] = `<span class=\"label label-fill label-info\">Viernes ${this.getFormatedDate(date)}</span>`;
        weekday[6] = `<span class=\"label label-fill label-info\">Sabado ${this.getFormatedDate(date)}</span>`;
        return weekday[date.getDay()];
      },
    },
  };
</script>
<style scoped>
.el-table .warning-row {
  background: oldlace;
}
table {
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>